import React, { useState } from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import {Button} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

export default function CheckoutForm(props) {

    const {application_id} = props;

    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async () => {

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setMessage(null);
        setIsProcessing(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: `${window.location.origin}/application/detail?app_id=${application_id}`,
            },
        });

        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsProcessing(false);
    };

    return (
        <>
            <PaymentElement id="payment-element" />
            <br/>
            <Box align={'center'}>
                <Button id="submit" style={{position:'absolute', bottom:'20px', left: '50%', transform: 'translateX(-50%)',backgroundColor:'#052F44', color:'white', borderRadius:'15px', fontSize:'13px', padding:'12px 24px'}} variant={'contained'} color={'primary'} disabled={isProcessing || !stripe || !elements} onClick={() => handleSubmit()}>
                    {isProcessing ? "Processing..." : "Pay now"}
                </Button>
            </Box>
            <br/>
            {/* Show any error or success messages */}
            {message && <div style={{color: "red"}}>{message}</div>}
        </>
    );
}